import { render, staticRenderFns } from "./CrearPercepcionCargasFamiliaHijos.vue?vue&type=template&id=10b970a4&scoped=true&"
import script from "./CrearPercepcionCargasFamiliaHijos.vue?vue&type=script&lang=js&"
export * from "./CrearPercepcionCargasFamiliaHijos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b970a4",
  null
  
)

export default component.exports